import BannerDesktop from '../Images/Homepage/banner-desktop.jpg';
import BannerMobile from '../Images/Homepage/banner-mobile.jpg';
import HomepageSecImage1 from '../Images/Homepage/homepage-sec1.jpg';
import HomepageSecImage2 from '../Images/Homepage/homepage-sec2.jpg';
import AboutImage from '../Images/Homepage/home-about.jpg';
// import MenuItem1 from '../Images/Menu/menu1.png';
// import MenuItem2 from '../Images/Menu/menu2.jpeg';
// import MenuItem3 from '../Images/Menu/menu3.jpeg';
// import MenuItem4 from '../Images/Menu/menu4.jpeg';
// import MenuItem5 from '../Images/Menu/menu5.jpeg';
// import MenuItem6 from '../Images/Menu/menu6.jpeg';

function Home() {
    return(
        <div>
            {/* homepage banner */}
            <div className="section-image">
                <img className="hidden-xs hidden-sm" style={{width:"100%"}} src={BannerDesktop} alt="Banner Desktop"/>
                <img className="visible-xs visible-sm" style={{width:"100%"}} src={BannerMobile} alt="Banner Desktop"/>
                <div className="section-title">
                    <p className="visible-xs visible-sm" id="homepage-text">Jackie's Dough and Co.</p>
                    <p className="hidden-xs hidden-sm" id="homepage-text-large">Jackie's Dough and Co.</p>
                    <br/>
                    <p id="homepage-bottom-text">Cookies, treats, and more!</p>
                </div>
            </div>

            {/* <h2>Follow me on Instagram!</h2>
            <h2><a href='https://instagram.com/jackiesdoughandco'>@jackiesdoughandco</a></h2> */}

            {/* menu grid */}
            {/* <h3>Handmade Sweet Treats!</h3>
            <div className="container-grid">
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem1} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem1} />
                </div>
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem2} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem2} />
                </div>
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem3} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem3} />
                </div>
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem4} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem4} />
                </div>
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem5} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem5} />
                </div>
                <div className="container-grid-div">
                    <img className="visible-xs visible-sm home-menu-img" alt="Menu Item" src={MenuItem6} style={{width:"110px"}} />
                    <img className="hidden-xs hidden-sm home-menu-img-lg" alt="Menu Item" src={MenuItem6} />
                </div>
            </div> */}

            {/* sections */}
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={HomepageSecImage1} alt="Homepage Section 1"/>
                        <div className="section-title">
                            <a href="/menu"><p className="section-text">Menu</p></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={AboutImage} alt="Homepage Section 1"/>
                        <div className="section-title">
                            <a href="/about"><p className="section-text">About Me</p></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-sm visible-xs">
                <div style={{width:"100%", margin:"auto"}} id="box-search">
                    <div className="section-image">
                        <img className="section-div" src={HomepageSecImage2} alt="Homepage Section 2"/>
                        <div className="section-title">
                            <a href="/contact"><p className="section-text">Contact</p></a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Desktop */}
            <div className="container">
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={HomepageSecImage1} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/menu"><p className="section-text">Menu</p></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={AboutImage} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/about"><p className="section-text">About Me</p></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="box hidden-sm hidden-xs">
                    <div style={{width:"100%"}} id="box-search">
                        <div className="section-image">
                            <img className="section-div" src={HomepageSecImage2} alt="Homepage Section 1"/>
                            <div className="section-title">
                                <a href="/services"><p className="section-text">Services</p></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hidden-sm hidden-xs"><br/><br/><br/><br/></div>
        </div>
    )
}
export default Home;